import { createTheme } from "@mui/material";

const applicationTheme = createTheme({
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 0,
            minHeight: 40,
            minWidth: 100
          },
        }, 
        variants: [
          {
              props: { variant: 'contained' },
              style: {
                  backgroundColor: "#0431a6",
                  fontWeight: 800,
                  textTransform: "none",
                  minWidth: 123
              }
          },
          {
            props: { variant: 'outlined' },
            style: {
              color:"#0431a6",
              borderColor: "#0431a6",
              fontWeight: 800,
              textTransform: "none"
            }
        }
      ]
      },
      MuiOutlinedInput: {
        styleOverrides:{
          root:{
            borderRadius:0
          }
        }
      },
      MuiIconButton:{
        styleOverrides:{
          root:{
            color: "rgba(0, 0, 0, 0.7)"
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
            root: {
                '&.Mui-checked': {
                    color: "#0431a6", 
                },
            }
        
          }  
      }
    },
  });
  
export default applicationTheme;  